const KEY_PREFIX = 'flyback-merchant-pref';

function keyFor(merchantId) {
  return `${KEY_PREFIX}:${merchantId || 'default'}`;
}

export function getMerchantPrefs(merchantId) {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(keyFor(merchantId));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function setMerchantPrefs(merchantId, patch) {
  if (typeof window === 'undefined') return {};
  const prev = getMerchantPrefs(merchantId);
  const next = { ...prev, ...patch };
  try {
    window.localStorage.setItem(keyFor(merchantId), JSON.stringify(next));
  } catch {}
  return next;
}
